/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'motion/react';
import * as _ from 'underscore';

let intervalId = 0;

class FlashMessage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isVisible: false,
            messages: [],
            exited: true
        };

        this.hideMessage = this.hideMessage.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {};

        if (props.app.messages.length) {
            let messages = props.app.messages,
                nextMessages = [];

            for (let i = 0; i < messages.length; ++i) {
                if (messages[i].messageType === 'MESSAGE_TYPE_FLASH') {
                    nextMessages.push(messages[i]);
                }
            }

            if (nextMessages.length || (state.messages.length && nextMessages.length === 0)) {
                nextState.messages = nextMessages;
            }

        } else {
            if (state.messages.length) {
                nextState.messages = [];
            }
        }

        return (Object.keys(nextState).length) ? nextState : null;
    }

    componentDidMount() {

        this.setState({
            isVisible: (this.state.messages.length) ? true : false
        });

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevState.messages.length !== this.state.messages.length && this.state.messages.length > 0) {
            this.setState({
                isVisible: true
            });
        } else if (prevState.messages.length !== this.state.messages.length && this.state.messages.length === 0) {
            this.setState({
                isVisible: false
            });
        }

    }

    hideMessage() {

        for (let i = 0; i < this.state.messages.length; ++i) {
            this.props.deleteMessageById(this.state.messages[i].id);
        }

        this.setState({
            isVisible: false
        });


    }

    render() {

        return (
            <AnimatePresence>
                {this.state.isVisible ? (
                    <motion.div
                        className="flash-message"
                        role="dialog"
                        aria-hidden="false"
                        aria-modal="true"
                        initial={{
                            opacity: 0,
                            transform: "translateY(-100%)"
                        }}
                        animate={{
                            opacity: 1,
                            transform: "translateY(0%)"
                        }}
                        exit={{
                            opacity: 0,
                            transform: "translateY(-100%)"
                        }}
                        onAnimationComplete={() => {
                            intervalId = window.setTimeout(() => {
                                this.hideMessage();
                            }, 5000);
                        }}>
                        <div className="flash-message-dismiss" onClick={this.hideMessage} role="button" aria-label="close">
                            <i className="fa fa-close"></i>
                        </div>
                        <div className="flash-message-content">
                            {this.state.messages.map((message, i) => {
                                return (
                                    <div key={i}>{message.message}</div>
                                );
                            })}
                        </div>
                    </motion.div>
                ) : null }
            </AnimatePresence>
        );

    }
}

FlashMessage.displayName = "FlashMessage";

FlashMessage.propTypes = {
    app: PropTypes.object,
    deleteMessageById: PropTypes.func
};

FlashMessage.defaultProps = {
    app: {},
    deleteMessageById: () => {}
};

export default FlashMessage;
